export const Mode = {
  Create: 1,
  Update: 2,
}
